import { useEffect } from 'react';

import i18n, { localeDirection } from '@/i18n';
import { useUiStore } from '@/stores/ui.store';

/**
 * Syncs document chrome (lang, dir, theme) and the i18next language with the UI
 * store. Renders nothing.
 */
export function ChromeSync(): null {
  const locale = useUiStore((s) => s.locale);
  const theme = useUiStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.lang = locale;
    root.dir = localeDirection(locale);
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }
  }, [locale]);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return null;
}
